var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { flyoutTransitionMixin } from '../FlyoutMenu/config';
var StyledLogoWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  fill: ", " !important;\n\n  /* Apply styles to the child component */\n  & > * {\n    fill: ", " !important;\n  }\n"], ["\n  ", "\n  fill: ", " !important;\n\n  /* Apply styles to the child component */\n  & > * {\n    fill: ", " !important;\n  }\n"])), flyoutTransitionMixin('fill'), function (props) { return props.theme.text; }, function (props) { return props.theme.text; });
export var SiteLogoWrapper = function (_a) {
    var Component = _a.component, props = __rest(_a, ["component"]);
    return (React.createElement(StyledLogoWrapper, null,
        React.createElement(Component, __assign({}, props))));
};
var templateObject_1;
